import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';

export enum SubscriptionTypeDTO {
  None,
  Trial,
  Active,
  Expired,
}

export enum SubscriptionIntervalDTO {
  Month = 'month',
  Year = 'year',
}

interface SubscriptionDTO {
  SubscriptionType: SubscriptionTypeDTO;
  Interval: SubscriptionIntervalDTO;
  Price: number;
  TrialStart: string;
  TrialEnd: string;
  TrialPeriodDays: number;
}

export const SUBSCRIPTION_QUERY_KEY = 'subscription';
export const SUBSCRIPTION_ENDPOINT = '/Adviser/Subscription/GetSubscription';

const fetchSubscription = (): Promise<SubscriptionDTO> => authFetch(SUBSCRIPTION_ENDPOINT);

export const useSubscriptionQuery = () =>
  useQuery(SUBSCRIPTION_QUERY_KEY, () => fetchSubscription(), { cacheTime: 0 });
